/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { UsersAuthzGetManagedPermissionsPermissionsOfGroupQueryResponse, UsersAuthzGetManagedPermissionsPermissionsOfGroupPathParams, UsersAuthzGetManagedPermissionsPermissionsOfGroup401, UsersAuthzGetManagedPermissionsPermissionsOfGroup403 } from "../models/UsersAuthzGetManagedPermissionsPermissionsOfGroup";

export function getUsersAuthzGetManagedPermissionsPermissionsOfGroupUrl(groupId: UsersAuthzGetManagedPermissionsPermissionsOfGroupPathParams["groupId"]) {
  const res = { method: 'GET', url: `/users-authz/v1/groups/${groupId}/permissions` as const }
  return res
}

/**
 * @description Requires CLIENT_ADMIN role or client API key
 * @summary Get all permissions for a specific group
 * {@link /users-authz/v1/groups/:groupId/permissions}
 */
export async function usersAuthzGetManagedPermissionsPermissionsOfGroup(groupId: UsersAuthzGetManagedPermissionsPermissionsOfGroupPathParams["groupId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<UsersAuthzGetManagedPermissionsPermissionsOfGroupQueryResponse, ResponseErrorConfig<UsersAuthzGetManagedPermissionsPermissionsOfGroup401 | UsersAuthzGetManagedPermissionsPermissionsOfGroup403>, unknown>({ method : "GET", url : getUsersAuthzGetManagedPermissionsPermissionsOfGroupUrl(groupId).url.toString(), ... requestConfig })
  return res.data
}